//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import CardTmpl from './subgroup/head/cardTmpl'
import Applicable from './subgroup/head/applicable'
import InsuranceTmpl from './subgroup/head/insuranceTmpl'
import ExplainList from './subgroup/head/explainList'

import BScroll from 'better-scroll'
import Swiper from './subgroup/swiper'
import Guarantee from '../assembly/guarantee'
import Nav from './subgroup/nav'
import { insurance } from '../../../model/api/detailService'
import { toApp } from '@/utils/appBridge'
import { store } from "@/observable/store"
import { Share } from '@/utils/commonUtils'
// import {hospitalCity,hospitalGrid} from '@/model/appointment/hospitalListService'
import {  store as locaStore  } from "@/views/reservation/store/store.js";
import { FactoryUtils } from "@/utils/FactoryUtils"    
import share from '@/components/toast/share'
import clearKeepAlive from '@/utils/mixin/mixinCache'
export default {
    name: "de",
    mixins:[clearKeepAlive],
    data(){
        return {
            productList:[],
            socialSecurity:0,
            imgSrc:'',
            templateFlag:'tk_irok',// 保险标示
            contentFlag:false,
            salesVolume:{},
            datailsInfo:{'id':1},
            content_list: [],
            nav_info:{},
            scrollTop:0,
            detailInfo:{},
            shareCircleCms:{},
            shareCms:{},
            payable_amount:0
        }
    },
    components:{
      Swiper,
      Guarantee,
      Nav,
      share,
      CardTmpl,
      Applicable,
      InsuranceTmpl,
      ExplainList
    },
    computed: {
        refid(){
            return store.refid
        },
    },
    watch: {
      detailInfo:{ //分享
        handler(newVal, oldVal) {
            let obj;
            let objCircle;
            if(this.shareCircleCms.share_title){
                obj = this.shareCms;
                objCircle = this.shareCircleCms;
            }else {
                obj = this.detailInfo.share;
                objCircle = this.detailInfo.shareCircle;
            }
            document.title = this.detailInfo.title;
            Share(obj,'sybao_ins_product_share_result_sys',objCircle)
        },
        deep: true
      },
      shareCircleCms:{//分享
        handler(newVal, oldVal) {
            let obj =this.shareCms;
            let objCircle = this.shareCircleCms;
            Share(obj,'sybao_ins_product_share_result_sys',objCircle)
        },
        deep: true
      },
    },
    activated(){      
        FactoryUtils.detailInfo().then(res=>{
          this.detailInfo = res;
        })
        
        window.addEventListener('scroll', this.handleScroll);    //绑定滚轮滚动事件
        document.documentElement.scrollTop = this.scrollTop
    },
    beforeRouteEnter:function(to, from, next) {//进入组件前执行。
        next(vm => {
          // vm.trak(from.path)
          if(from.path == '/distribution'){
            vm.shareShow()
          }

        })
    },
    created() {
        if(this.$route.query.templateFlag){
            this.templateFlag = this.$route.query.templateFlag;
        }
        //判断 第三方 优惠路由
        let plan ='';
        if(this.$route.path == '/detailsA'){
            plan = `${this.templateFlag}?modify=23k`
        }else{
            if(this.$route.query.modify){
                plan = `${this.templateFlag}?modify=${this.$route.query.modify}`
            }else{
                plan = this.templateFlag
            }
        }
        FactoryUtils.detailInfo().then(res=>{
            console.log('21212121--------',res)
          this.detailInfo = res;
        })
        
        document.documentElement.scrollTop = 0;
        insurance(plan).then(data=>{
            this.datailsInfo = data
            if(data.cache){
                let cache = JSON.parse(data.cache)

                cache.details_img && (this.imgSrc = cache.details_img);
                cache.title && (this.datailsInfo.title = cache.title)
                if(cache.product_list && cache.product_list.length>0){
                    this.productList = cache.product_list
                }
                if(cache.share && cache.share.share_content){
                    this.shareCms = {
                        shareContent: cache.share.share_content,
                        shareTimelineContent:cache.share.share_title,
                        shareImgurl:cache.share.share_imgurl,
                        shareTitle:cache.share.share_title,
                        shareUrl: `${window.location.href}`,
                        rightBtnStatus: 1
                    },
                    this.shareCircleCms =  {
                        shareContent: cache.share_circle.share_content,
                        shareTimelineContent:cache.share_circle.share_content,
                        shareImgurl:cache.share_circle.share_imgurl,
                        shareTitle:cache.share_circle.share_content,
                        shareUrl: `${window.location.href}`,
                        rightBtnStatus: 1
                    }
                }
                
            }else{
                this.imgSrc = this.detailInfo.imgSrc
            }
            if(data.payable_amount){
                this.payable_amount=data.payable_amount/100
            }
            data.append_amount = data.append_amount/100;
            data.amountPrice = data.amount = data.amount/100;
            if(data.coupon){
                for(let i of data.coupon){
                    data.amountPrice  = data.amountPrice - i.amount/100
                }
            }
            
            this.socialSecurity = this.datailsInfo.stage_info.stage_active
            this.content_list = data.insure_content;
            this.nav_info = this.datailsInfo
            this.salesVolume = data.sales_volume;
            this.contentFlag = true;
            this.bus.$emit("navinfo",this.nav_info);
        })
    },
    mounted(){
        window.addEventListener('scroll', this.handleScroll);    //绑定滚轮滚动事件
        this.$on("hook:beforeDestroy", () => {
            window.removeEventListener('scroll', this.handleScroll);
        })

        // 埋点
        this.STATISTICS('load','sybao_ins_product_info_page')


    },
    methods: {
        // 展示分享弹框
        shareShow(){
          this.$nextTick(() => {
            this.$refs.shareToast.showoast()
          })
        },
        handleScroll(){
            this.scrollTop = window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop||0
        },
        statisticsClick(e){ // nav导航统计
            const buriedList = new Map()
            .set('0', 'sybao_ins_proinfo_featurenavigation_click')
            .set('1', 'sybao_ins_proinfo_evaluatenavigation_click')
            .set('2', 'sybao_ins_proinfo_claimnavigation_click')
            .set('3', 'sybao_ins_proinfo_paynavigation_click');
            this.STATISTICS('click',buriedList.get(e))
        }
    }
}
